export default (timestamp, showTime = false) => {
  const initialDate = new Date(timestamp).toISOString();
  const splittedDates = initialDate.split(`T`);
  let date = splittedDates[0];
  if(showTime) {
    date += ` ` + splittedDates[1].replace(/\.\S*/gi, ``);
  }
  return date;
};
